import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';

import Link from 'components/link';
import Select from 'components/select';
import buttonFactory from './button';
import buttonGroupFactory from './button-group';
import copyButtonFactory from './copy-button';
import fullscreenButtonFactory from './fullscreen-button';

const Button = buttonFactory(FontAwesome, Link);
const ButtonGroup = buttonGroupFactory(Button, Select);
const CopyButton = copyButtonFactory(Button, ReactTooltip);
const FullscreenButton = fullscreenButtonFactory(Button, ReactTooltip);

export default Button;
export { Button, ButtonGroup, CopyButton, FullscreenButton };
